import { render } from "./FormRecrutamentoFase01.vue?vue&type=template&id=10d365db"
import script from "./FormRecrutamentoFase01.vue?vue&type=script&lang=js"
export * from "./FormRecrutamentoFase01.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__